export default {"src":"/_next/static/media/MetalWeight-platinum.aca2968a.svg","height":28,"width":32};